module.exports = __webpack_public_path__ + "img/banner4.149a63d7.jpg";